import React, { useMemo, useState } from "react";
import I18n from "../../localization";
import {
  Box,
  Button,
  Typography,
  Checkbox,
  TextField,
} from "@material-ui/core";
import { makeStyle } from "./style";
import { AIR_SYSTEM_LOCAL_STORAGE, DEVICE_PROVISIONING_ERRORS, PAGES, POWER_PLATE_GUIDE_URL, PROVISIONING_FAILURE_STAGES, STATUS } from "../../utils/constant";
import { Header } from "../../components/Header";
import {
  PopUp,
  ScanditScannerPlugin,
} from "../../components";
import Icon from "../../utils/icons";
import IQAirSerialNumber from "../../components/IQAirSerialNumberPopup/IQAirSerialNumber";
import HCServices from "../../services/hcServices";
import ProvisionStepper from "./provisionStepper";
import settings from "../../utils/settings"
import { SERVICES } from "../../services/constants"
import { validateName } from "../../utils/utility";
import InstallationGuide from "./installationGuide/InstallationGuide";

const AirDeviceIntegration = (props) => {
  const classes = makeStyle();
  const IQ_AIR_MODEL = {
    IQ_AIR_HUB: {
      ID: 'IQ_AIR_HUB',
      HEADER_TITLE: I18n.t('mobile.AirDeviceProvisioning.addIQAirHubTitle'),
      CONSENT_TEXT: I18n.t('mobile.AirDeviceProvisioning.tncCheckAsk'),
      SETUP_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading1A"),
      SETUP_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading1A"),
      SETUP_SUCCESS_HEADING: "IQ Air (Primary) is successfully set up",
      SETUP_SUCCESS_SUBHEADING: '',
      SETUP_FAIL_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFail"),
      SETUP_FAIL_HEADINGA1: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFailA1"),
      SETUP_FAIL_HEADINGA2: I18n.t("mobile.AirDeviceProvisioning.comissioningHeadingFailA2"),
      DEVICE_TYPE: I18n.t("mobile.AirDeviceProvisioning.iqAirPrimary"),
    },
    IQ_AIR_DISPLAY: {
      ID: 'IQ_AIR_DISPLAY',
      HEADER_TITLE: I18n.t('mobile.AirDeviceProvisioning.addIQAirDisplayTitle'),
      CONSENT_TEXT: I18n.t('mobile.AirDeviceProvisioning.tncCheck'),
      SETUP_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading1B"),
      SETUP_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading1B"),
      SETUP_SUCCESS_HEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningHeading2B"),
      SETUP_SUCCESS_SUBHEADING: I18n.t("mobile.AirDeviceProvisioning.comissioningSubHeading2B"),
      DEVICE_TYPE: I18n.t("mobile.AirDeviceProvisioning.iqAirSecondary"),
    }
  }
  const { isPromoPage,onGoBack,handleClick, provisioningType, redirectToStatus, setToast, siteId, createNewSite, iqAirModel, screenStatus,isHardwareInstallationPending,isHardwareInstallationDone } = props;
  const registrationScreenStates = {
    SCANING_OR_MANUALLY_ENTER_SN: 0,
    VERIFYING_SN: 1,
    SN_VERIFIED: 2,
    CREATING_SITE: 3,
    LINKING_DEVICE: 4,
    DEVICE_LINKED_SUCCESSFULLY: 5,
    DEVICE_LINKED_FAIL: 6,
    INSTALL_WITH_POWER_PLATE: 7
  };

  const [screenState, setScreenState] = useState(
    registrationScreenStates[screenStatus] || registrationScreenStates.SCANING_OR_MANUALLY_ENTER_SN
  );
  const [isOpen, setIsOpen] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [siteIdToLinked, setSiteIdToLinke] = useState(createNewSite ? '' : siteId)
  const [scanStatus, setScanStatus] = useState(true);
  const [showReEnterOrRescanMsg, setShowReEnterOrRescanMsg] = useState(false);
  const [instructionChecks, setInstructionChecks] = useState({
    connectDisplay: false,
    followConfig: false,
  });
  const [progressSteps, setProgressSteps] = useState({step1:100, step2:0, step3:0})
  const [iqAirDetails, setIQAirDetails] = useState({ name: '', dbName: '', deviceId: '' })
  const [IQAirNameError, setIQAirNameError] = useState({ status: false, message: ''})
  const [showInstallationGuide, setShowInstallationGuide] = useState(((iqAirModel === IQ_AIR_MODEL.IQ_AIR_DISPLAY.ID && !isHardwareInstallationDone) || isHardwareInstallationPending) ? true:false)

  const getNACountriesAnimation = () => false;

  const scanditLicenseKey = useMemo(() => {
    const licenseKey = settings.getCoreUrl(``, SERVICES.SCANDIT)
    return licenseKey.slice(0, licenseKey.lastIndexOf("/"))
  }, [])

  const headerTitle = useMemo(() => {
    if(screenState === registrationScreenStates.DEVICE_LINKED_SUCCESSFULLY && iqAirModel === IQ_AIR_MODEL.IQ_AIR_DISPLAY.ID ){
      return IQ_AIR_MODEL[iqAirModel].HEADER_TITLE
    }
     if((screenState === registrationScreenStates.DEVICE_LINKED_SUCCESSFULLY || screenState === registrationScreenStates.DEVICE_LINKED_FAIL) && iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID ){
      return 'Save IQ Air (Primary) Details'
    }
    return screenState === registrationScreenStates.SCANING_OR_MANUALLY_ENTER_SN ? IQ_AIR_MODEL[iqAirModel].HEADER_TITLE : I18n.t(`mobile.AirDeviceProvisioning.completeSystemSetup`)
  }, [screenState])
  
  const handleErrorFlow = (stage) => {
    let messageKey = ''
    if([PROVISIONING_FAILURE_STAGES.INVALID_SN, PROVISIONING_FAILURE_STAGES.SN_ALREADY_EXIST].includes(stage)) {
      setScreenState(registrationScreenStates.SCANING_OR_MANUALLY_ENTER_SN)
      setShowReEnterOrRescanMsg(true)
      messageKey = stage === PROVISIONING_FAILURE_STAGES.SN_ALREADY_EXIST ? "serailNumberAlreadyRegistered" : "validationFailed"
    } else if(stage === PROVISIONING_FAILURE_STAGES.SITE_CREATION) {
      handleClick(PAGES.CONFIRM_SITE)
      messageKey = "creatingSiteFailed"
    } else if(stage === PROVISIONING_FAILURE_STAGES.SITE_DEVICE_LINK) {
      setScreenState(registrationScreenStates.SCANING_OR_MANUALLY_ENTER_SN)
      setShowReEnterOrRescanMsg(true)
      messageKey = "linkingFailed"
    }
    messageKey && setToast({ status: true, message: I18n.t(`mobile.AirDeviceProvisioning.${messageKey}`), type: "error" });
  }

  const createSiteForNewUser = async () => {
    setScreenState(registrationScreenStates.CREATING_SITE);
    try {
      const siteData = JSON.parse(localStorage.getItem("siteAddressDetails")) || {};
      const hcUserId = localStorage.getItem("hcUserId");
      const payload = {
        name: siteData?.siteName,
        stage: 4,
        site_type: 1,
        root_device_type: "IQ_AIR",
        ...(hcUserId && { user_info: { owner_id: parseInt(hcUserId) } }),
        address_info: {
          address1: siteData?.address1,
          address2: siteData?.address2,
          city: siteData?.city,
          state: siteData?.state,
          country: siteData?.country,
          latitude: siteData?.latitude,
          longitude: siteData?.longitude,
          zip: siteData?.zip
        },
      };
      const res = await HCServices.createSite(payload);
      if (res && res.status === STATUS.SUCCESS && res.data?.id) {
        localStorage.removeItem("siteAddressDetails");
        return res.data.id;
      }
      else {
        throw new Error('creatingSiteFailed')
      }
    } catch (err) {
      handleErrorFlow(PROVISIONING_FAILURE_STAGES.SITE_CREATION);
      return null;
    }
  }

  const linkDeviceToSite = async (siteID, sn) => {
    try {
      const res = await HCServices.linkDevice(siteID, sn)
      if (res.status === STATUS.SUCCESS && res.data) {
        setScreenState(registrationScreenStates.DEVICE_LINKED_SUCCESSFULLY);

        setIQAirDetails({
          name: res.data?.name,
          dbName: res.data?.name,
          deviceId: res.data?.['device-id']
        });

        setToast({
          status: true,
          message: I18n.t("mobile.AirDeviceProvisioning.deviceLinkedSuccess"),
          type: "success"
        });

        return true;
      } 
      if (res.httpStatus === 550) {
        const { errorStatus } = res ;
        const failureStage = errorStatus && DEVICE_PROVISIONING_ERRORS.hasOwnProperty(errorStatus) ? DEVICE_PROVISIONING_ERRORS[errorStatus] : null;

        if (failureStage) {
          handleErrorFlow(failureStage);
        } else {
          setScreenState(registrationScreenStates.DEVICE_LINKED_FAIL);
        }

        return false;
      }

      // setting this in 500 error response as well.
      setScreenState(registrationScreenStates.DEVICE_LINKED_FAIL);
      return false;
    } catch (err) {
      // setting the screen in all failure scenarios 
      setScreenState(registrationScreenStates.DEVICE_LINKED_FAIL);
      return false;
    }
  }

  // start commissioning flow
  const startCommissioningFlow = async (sn) => {
    setProgressSteps({...progressSteps, step2: 10})
    setScreenState(registrationScreenStates.VERIFYING_SN);
    let site_id = siteIdToLinked
    if (!siteIdToLinked) {
      site_id = await createSiteForNewUser()
      if (!site_id) return;
      setSiteIdToLinke(site_id)
    }
    
    setProgressSteps({...progressSteps, step2: 30})
    const linked = await linkDeviceToSite(site_id, sn)
    if (!linked) return;
    setProgressSteps({...progressSteps, step2: 100})
  }

  const handleBack = () => {
    if (iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && [registrationScreenStates.SCANING_OR_MANUALLY_ENTER_SN, registrationScreenStates.DEVICE_LINKED_SUCCESSFULLY].includes(screenState)) {
      handleClick(PAGES.CONFIRM_SITE)
    }else if(iqAirModel === IQ_AIR_MODEL.IQ_AIR_DISPLAY.ID){ 
      handleClick(PAGES.LINK_HVAC_TO_THERMOSTAT)
    }else if ([registrationScreenStates.INSTALL_WITH_POWER_PLATE].includes(screenState)) {
      setScreenState(registrationScreenStates.DEVICE_LINKED_SUCCESSFULLY)
    }

  }

  const updateAirDeviceName = async () => {
    const payload = { name: iqAirDetails.name.trim()}
    const response = await HCServices.setAirDeviceSettings(payload, siteIdToLinked, iqAirDetails.deviceId)
    if(response.status !== STATUS.SUCCESS) throw new Error()
  }

  const syncAirDeviceSettings = async () => {
    const response = await HCServices.getAirDevices(siteIdToLinked)
    if (response.status === STATUS.SUCCESS && response.data) {
      localStorage.removeItem(AIR_SYSTEM_LOCAL_STORAGE + ":" + siteIdToLinked)
      localStorage.setItem(AIR_SYSTEM_LOCAL_STORAGE + ":" + siteIdToLinked, JSON.stringify([...response.data]))
    } else {
      throw new Error()
    }
  }

  const handleStartInstructionForPrimary = async () => {
    setShowLoader(true)
    if(iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && iqAirDetails?.name?.trim() !== iqAirDetails?.dbName?.trim()){
      await updateAirDeviceName()
    }
    setShowLoader(false)
    setShowInstallationGuide(true)
  }
  const handleViewSystem = async () => {
    try {
      // setShowLoader(true)
      // if(iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && iqAirDetails?.name?.trim() !== iqAirDetails?.dbName?.trim()){
      //   await updateAirDeviceName()
      // }
      
      redirectToStatus(siteIdToLinked, 'VIEW_SYSTEM')
    } catch (error) {
      console.log("Error in viewing system: ", error)
      setToast({ status: true, message: I18n.t(`mobile.common.errorMsg`), type: "error" })
    } finally {
      setShowLoader(false)
    }
  }

  const handleNameChange = (e) => {
    const value = e.target.value
    setIQAirDetails({ ...iqAirDetails, name: value })
    const status = validateName(value)
    if(status !== true) {
      setIQAirNameError({ status: true, message: status})
    } else {
      setIQAirNameError({ status: false, message: ''})
    }
  }

  const renderContent = () => {
    switch (screenState) {
      // Step 1: Scan or manual entry
      case registrationScreenStates.SCANING_OR_MANUALLY_ENTER_SN:
        return (
          <>
            <Box className={classes.qrScanBox}>
              {scanditLicenseKey && (
                <ScanditScannerPlugin
                  scanditLicenseKey={scanditLicenseKey}
                  qrCodeSuccessCallback={(sn) => startCommissioningFlow(sn)}
                  scanStatus={scanStatus}
                  getNACountriesAnimation={getNACountriesAnimation}
                  provisioningType={provisioningType}
                />
              )}

              <Typography className={classes.scanDescription}>
                {showReEnterOrRescanMsg ? I18n.t("mobile.AirDeviceProvisioning.reScanBarcode") : I18n.t("mobile.AirDeviceProvisioning.scanBarcode")}
              </Typography>

              <Typography className={classes.orSep}>
                {I18n.t("mobile.common.or")}
              </Typography>
              <PopUp
                open={isOpen}
                content={
                  <IQAirSerialNumber
                    iqAirModel={iqAirModel}
                    closePopUp={() => {
                      setScanStatus(true);
                      setIsOpen(false);
                    }}
                    onConfirm={(sn) => {
                      setIsOpen(false);
                      startCommissioningFlow(sn);
                    }}
                  />
                }
              />
            </Box>
            <Box className={classes.enterSerialBtnBoxStyle}>
              <Button
                className={classes.buttonSerialStyle}
                onClick={() => {
                  setScanStatus(false);
                  setIsOpen(true);
                }}
              >
                {showReEnterOrRescanMsg ? I18n.t('mobile.AirDeviceProvisioning.reEnterSerialNumberManually') : I18n.t("mobile.AirDeviceProvisioning.enterSerialNumberManually")}
              </Button>
            </Box>
          </>
        );

      case registrationScreenStates.VERIFYING_SN:
      case registrationScreenStates.SN_VERIFIED:
      case registrationScreenStates.CREATING_SITE:
      case registrationScreenStates.LINKING_DEVICE:
        return (
          <Box className={classes.commissioningSuccessContainer}>
            <ProvisionStepper activeStep={1} progressSteps={progressSteps} />
            <Icon src={"systemSetup"} alt="Setup" className={classes.successImage}/>
            <Typography className={classes.comissioningHeading}>{IQ_AIR_MODEL[iqAirModel].SETUP_HEADING}</Typography>
            <Typography className={classes.comissioningSubHeading}>{IQ_AIR_MODEL[iqAirModel].SETUP_SUBHEADING}</Typography>
          </Box>
        )

      case registrationScreenStates.DEVICE_LINKED_SUCCESSFULLY:
        let allChecked = true;
        if(iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID){
          allChecked = iqAirDetails.name && !IQAirNameError.status
        }
        
        
        return (
          <div className={classes.bodyMainContainer} >
            
            <Box className={classes.commissioningSuccessContainer}>
              {iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && <ProvisionStepper
                activeStep={3}
                progressSteps={{ step1: 100, step2: 100, step3: 100 }}
                incomplete={!allChecked}
              />}
              {
                allChecked ?
                  <Icon src={"systemSetupSuccess"} alt="Success" className={classes.successImage} /> 
                  : <Icon src={"systemSetup"} alt="Success" className={classes.successImage} />
                }
             
              <Typography className={classes.comissioningHeading}>
                {IQ_AIR_MODEL[iqAirModel].SETUP_SUCCESS_HEADING}
              </Typography>
              {iqAirModel === IQ_AIR_MODEL.IQ_AIR_DISPLAY.ID ? (
                 <Typography className={classes.comissioningSubHeading}>{IQ_AIR_MODEL[iqAirModel].SETUP_SUCCESS_SUBHEADING}</Typography>
              ) : (
                <>
                  <Box className={classes.hvacInputNameConatiner}>
                    <TextField
                      className={classes.hvacInputNameField}
                      value={iqAirDetails.name}
                      onChange={handleNameChange}
                      label={I18n.t("mobile.AirDeviceProvisioning.iqAirInputLabel")}
                      variant="standard"
                    />
                    {IQAirNameError.status && <p className={classes.errorMsg}>{IQAirNameError.message}</p>}
                  </Box>
                  {/* <Box className={classes.instructionsContainer}>
                    <Typography className={classes.instructionHeading}>
                      {I18n.t("mobile.AirDeviceProvisioning.furtheerInst")}
                    </Typography>
                    <span className={classes.instructionSubheading}>
                      {I18n.t(
                        "mobile.AirDeviceProvisioning.furtheerInstSubHeading"
                      )}
                    </span>
                    <Box className={classes.tnc}>
                      <Checkbox
                        checked={instructionChecks.connectDisplay}
                        onChange={(e) =>
                          setInstructionChecks((prev) => ({
                            ...prev,
                            connectDisplay: e.target.checked,
                          }))
                        }
                        color="primary"
                      />
                      <Typography className={classes.tncDescription}>
                        {I18n.t("mobile.AirDeviceProvisioning.furtheerInstTitle1")}
                      </Typography>
                    </Box>

                    <Box className={classes.tnc}>
                      <Checkbox
                        checked={instructionChecks.followConfig}
                        onChange={(e) =>
                          setInstructionChecks((prev) => ({
                            ...prev,
                            followConfig: e.target.checked,
                          }))
                        }
                        color="primary"
                      />
                      <Typography className={classes.tncDescription}>
                        {I18n.t("mobile.AirDeviceProvisioning.furtheerInstTitle2")}
                      </Typography>
                    </Box>
                  </Box> */}

                  <Box className={classes.nextHardwareInstallationContainer}>
                    <Box>
                       <Typography className='title'>
                          Next: Hardware Installation
                       </Typography>
                       <Typography className='subtitle'>
                            Follow the in-app guide to install your IQ Air. 
                        </Typography>
                    </Box>
                    <Box>
                      <Typography className='subtitle'>
                          Installing with Power Plate? <span style={{color:'#01B5DE'}} onClick={()=>{setScreenState(registrationScreenStates.INSTALL_WITH_POWER_PLATE)}}>Click here</span>
                      </Typography>
                    </Box>
                  </Box>
                </>
              )}
              
            </Box>
            <Box className={classes.buttonContainer}>
             
              {iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && 
                showLoader ? (
                  <Box className={classes.loaderBtn}>
                    <Icon src={"loaderV4"} width="40px" height="40px" />
                  </Box>
                ):
                (
                <Button
                  className={classes.buttonStyle}
                  disabled={!allChecked}
                  onClick={() => isHardwareInstallationDone ? handleViewSystem() : handleStartInstructionForPrimary()}
                >
                 { isHardwareInstallationDone ? I18n.t("mobile.AirDeviceProvisioning.viewSystemBtn") : 'Start Installation'}
                </Button>
              )}
            </Box>
          </div>
        )

        case registrationScreenStates.DEVICE_LINKED_FAIL:        
        return (
          <>
            <Box className={classes.commissioningSuccessContainer}>
              <ProvisionStepper
                activeStep={2}
                progressSteps={{ step1: 100, step2: 100, step3: 0 }}
                incomplete={true}
              />
               <Icon
                src={"systemSetupFail"}
                alt="Success"
                className={classes.successImage}
              />
             
              <Typography className={classes.comissioningHeading}>
                {IQ_AIR_MODEL[iqAirModel].SETUP_FAIL_HEADING}
              </Typography>
              <Typography className={classes.comissioningSubHeading}>{IQ_AIR_MODEL[iqAirModel].SETUP_FAIL_HEADINGA1}</Typography>
              <Typography className={classes.comissioningSubHeading}>{IQ_AIR_MODEL[iqAirModel].SETUP_FAIL_HEADINGA2}</Typography>
            
            </Box> 
                
            <Box className={classes.buttonContainer}>
              <Button
                className={classes.buttonRetry}
                onClick={() => {
                  handleClick(PAGES.AIR_DEVICES_PROVISION)
                }}
              >
                {I18n.t('mobile.AirDeviceProvisioning.comissioningFailRetry')}
              </Button>
            </Box>
          </>
        )

        case registrationScreenStates.INSTALL_WITH_POWER_PLATE:
          return (
            <div className={classes.bodyMainContainer} >
              <Box className={classes.commissioningSuccessContainer}>
               {iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && <ProvisionStepper
                activeStep={2}
                progressSteps={{ step1: 100, step2: 100, step3: 100 }}
                incomplete={true}
              />}
                
                <Icon src={"systemSetupSuccess"} alt="Success" className={classes.successImage} /> 
              
                <Typography className={classes.comissioningHeading}>
                 Install the Power Plate
                </Typography>
                   
                <Typography className={classes.comissioningSubHeading} style={{marginBottom:'20px'}}>
                    Follow the instructions in the &nbsp; 
                    <a href={POWER_PLATE_GUIDE_URL} target="_blank"
                      style={{color:'#01B5DE', textDecoration:'none'}}
                    >Power Plate Installation Guide</a> &nbsp;  to complete the hardware installation.
                </Typography>
                <Typography className={classes.comissioningSubHeading}>
                  When finished, return here and  tap View System.
                </Typography>
                        
                  
                
              </Box>
              <Box className={classes.buttonContainer}>
                
                {iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID && 
                  showLoader ? (
                    <Box className={classes.loaderBtn}>
                      <Icon src={"loaderV4"} width="40px" height="40px" />
                    </Box>
                  ):
                  (
                  <Button
                    className={classes.buttonStyle}
                    onClick={handleViewSystem}
                  >
                    {I18n.t("mobile.AirDeviceProvisioning.viewSystemBtn")}
                  </Button>
                )}
              </Box>
            </div>
          )

      default:
        return null;
    }
  };

  if (showInstallationGuide) {
    return (
      <InstallationGuide
        onBack={() =>{
        
           if(isHardwareInstallationPending){
            return handleClick('',PAGES.AIR_DEVICE_INTEGRATION)
           }
           if(isPromoPage){
            onGoBack()
            return
           }
           setShowInstallationGuide(false)
          }}
        onViewSystem={handleViewSystem}
        isDarkMode={props.isDarkMode}
        handleClick={handleClick}
        isIQAirDisplay={iqAirModel === IQ_AIR_MODEL.IQ_AIR_DISPLAY.ID}
      />
    );
  }

  return (
    <>
      <Header
        title={headerTitle}
        onClick={handleBack}
      />
      {renderContent()}
    </>
  );
};

export default AirDeviceIntegration;
